import { Component, Injector, OnInit, Input } from '@angular/core';
import { CasMetadataNode, NoneNode } from '../../../../classes/CasMetadataNode';
import { BaseFormComponent } from '../base-form.component';
import _ from 'lodash';
import { SubjectManager } from '../../../../../../common/js/subjectManager/SubjectManager';

@Component({
  moduleId: module.id,
  selector: 'basic-checkbox',
  templateUrl: './basic-checkbox.component.html',
})
export class CheckboxBasicComponent extends BaseFormComponent implements OnInit {
  inputText: boolean;
  @Input() propertyName: string;
  @Input() showTitle: boolean;
  @Input() skipModelUpdate: boolean;
  @Input() labelText: string;
  componentId: string;

  constructor(protected injector: Injector) {
    super(injector);
    this.showTitle = true; // some control types like multi control splitter already shows copy, don't show again
  }

  ngOnInit() {
    this.componentId = this.getComponentId();
    this.updateFromModel();
  }

  private handleNoneNode(node) {
    // If the value was reset from true to false, clear children
    if (node instanceof NoneNode) {
      // If the node is "None of the above", uncheck siblings
      for (let i = 0; i < node.parent.children.length; i++) {
        const child = node.parent.children[i];

        if (node === child) {
          break;
        } else if (child.hasValue(child.prop)) {
          child.resetVal();
          child.resetChildren();

          // Have to publish sibling checkbox state change event so that
          // any reflexive questions of these checkboxes can update their
          // visibility. Hope this is the only case when resets have to publish
          const propertyName = child.prop.split('.').join('_') + '_changed';
          SubjectManager.publish(propertyName);
        }
      }
    } else {
      // If the value was set to true, find a corresponding none node and reset it.
      // Get the node's parent and check for a next sibling "None of the above"
      const none = _.find(node.parent.children, function (child) {
        return child instanceof NoneNode;
      });

      if (none instanceof CasMetadataNode) {
        none.resetVal();
        const prop = this.propertyName || this.questionItem.prop;
        const propertyName = prop.split('.').join('_') + '_changed';
        SubjectManager.publish(propertyName);
      }
    }
  }

  updateFromModel() {
    if (this.skipModelUpdate) {
      return;
    }
    this.cdRef.detectChanges();
    const prop = this.propertyName || this.questionItem.prop;
    const value = this.getValue(prop);
    this.inputText = value;
  }

  getComponentId() {
    const prop = this.propertyName || this.prop; // this.prop -> involves customProp when the question has more than one binding
    return this.questionItem.id + '_' + prop;
  }

  resetValue() {
    this.inputText = false;
  }

  async trigger() {
    const prop = this.propertyName || this.questionItem.prop;
    await this.validateAndSet(prop, this.inputText);
    this.handleNoneNode(this.questionItem);
  }
}
